<div class="onboarding-container">
  <!-- Step Indicator -->
  <div class="step-indicator">
    <div class="step-circle">Step 2</div>
  </div>

  <!-- Dashboard Image -->
  <div class="dashboard-image-section">
    <div>
      <img src="assets/images/onboarding-dashboard.png" alt="Complete your profile" class="dashboard-image">
    </div>
  </div>

  <!-- Description Text -->
  <div class="description-text">
    <h2>Complete your profile</h2>
  </div>

  <!-- Next Button -->
  <div class="action-section">
    <button class="next-btn" (click)="onNext()">
      Next
    </button>
  </div>

  <!-- Pagination Dots -->
  <div class="pagination-dots">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot active"></div>
    <div class="dot"></div>
  </div>
</div>
